import axios from '../../helpers/axios-setup';

export const getSuggestedPrereqs = (data: number[]) => axios.put(`/certifications/pre-requisites`, data);
